import {clinicActions} from '../actionCreators';

const InitialPatientDetails={
    clinicMap:{},
    clinicInfo:{},
    userClinics: [],
    selectedClinicId: "",
    clinicLocations: [],
    clinicDashboards: {},
    userInvitations: [],
    clinicUsers: [],
    clinicUsersMetrics: {
        total_entries: 0,
        expired_invites: 0,
        pending_invites: 0,
        cancelled_invites: 0,
        active_users: 0,
        deactivated_users: 0
    },
    clinicAccessRoles: [],
    platformPermissions: [],
    clinicAllRoles: [],
    dataImportHistoryList:[],
    clinicLogo:null
}

const clinicReducer=(state=InitialPatientDetails, action)=>{
    switch(action.type){
        case clinicActions.UPDATE_USER_CLINICS : {
            const st = {...state};
            const clinicMap = action.payload.toMap("clinic_id");
            st.selectedClinicId && (st.clinicInfo = (clinicMap[st.selectedClinicId] || {}),st.clinicLogo = st.clinicInfo?.logo)
            return {...st, userClinics : action.payload,clinicMap }
        }
        case clinicActions.UPDATE_USER_SELECTED_CLINIC : {
            const st = {...state};
            const clinicMap = st.userClinics.toMap("clinic_id");
            st.clinicInfo = clinicMap[action.payload] || {};
            st.clinicLogo = st.clinicInfo?.logo;
            return {...st,clinicMap, selectedClinicId : action.payload}
        }
        case clinicActions.UPDATE_CLINIC_LOCATIONS : {
            return {...state, clinicLocations : action.payload }
        }
        case clinicActions.UPDATE_DASHBOARDS_LIST : {
            return {...state, clinicDashboards : {...(action.reset?{}:state.clinicDashboards), ...(action.persistDefault && state.clinicDashboards[action.persistDefault]?{}:action.payload) } }
        }
        case clinicActions.UPDATE_USER_INVITATIONS : {
            return {...state, userInvitations : action.payload }
        }
        case clinicActions.UPDATE_CLINIC_USERS : {
            return {...state, clinicUsers : action.payload }
        }
        case clinicActions.UPDATE_CLINIC_USER_METRICS : {
            return {...state, clinicUsersMetrics : action.payload }
        }
        case clinicActions.UPDATE_CLINIC_LOGO : {
            const userClinics = [
                ...state.userClinics.map((item) => {
                    if(item.clinic_id === action.payload.clinicId) {
                      return {
                        ...item,  
                        logo: action.payload.logo
                      }
                    }
                    return item;
                  })
            ];
            const clinicMap = userClinics.toMap("clinic_id");
            return{...state, clinicLogo:action.payload.logo,userClinics,clinicMap,clinicInfo :clinicMap[action.payload.clinicId]}  
        }
        case clinicActions.UPDATE_CLINIC_ACCESS_ROLES : {
            return {...state, clinicAccessRoles : action.payload }
        }
        case clinicActions.UPDATE_PLATFORM_PERMISSIONS : {
            return {...state, platformPermissions : action.payload }
        }
        case clinicActions.UPDATE_CLINIC_ALL_ROLES : {
            return {...state, clinicAllRoles : action.payload }
        }
        case clinicActions.DATA_IMPORT_HISTORY_LIST : {
            return {...state, dataImportHistoryList : action.payload }
        }
        default:{
            return state
        }
    }
}

export default clinicReducer;